import ReactDOM from "react-dom";
import Card from "./Card";

const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title = "Potwierdzenie",
  message = "Czy na pewno chcesz wykonać tę akcję?",
  confirmText = "Potwierdź",
  cancelText = "Anuluj",
  variant = "danger" // "danger" or "warning"
}) => {
  if (!isOpen) return null;

  const confirmButtonStyles = variant === "danger"
    ? "bg-red-600 hover:bg-red-700 text-white"
    : "bg-yellow-500 hover:bg-yellow-600 text-white";

  return ReactDOM.createPortal(
    <div>
      <div
        className="fixed left-0 top-0 w-full h-full bg-black bg-opacity-50 flex z-50"
        onClick={onCancel}
      />
      <Card className="fixed w-full max-w-[400px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-sm text-gray-600 mb-6">{message}</p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${confirmButtonStyles}`}
          >
            {confirmText}
          </button>
        </div>
      </Card>
    </div>,
    document.getElementById("modal-root")
  );
};

export default ConfirmDialog;
